export default __webpack_public_path__ + "static/media/house6.5a28f598.jfif";